<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ii"></a><em class="italic">For Mum and Dad who showed me that learning was important.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?4a0b4c42